/**
 * URL Manager
 *
 * This service provides helper function for working
 * with the browser's URL, so that we can update the URL
 * as a user searches and restore their search when they
 * visit a bookmark or share a link.
 */

export function getBase(): string {
  return parseUrlParams()['q'] || ''
}


export function setBase(base: string) {
  const query = base.length > 0 ? '?q=' + base : '/'
  history.replaceState(null, document.title, query)
}


function parseUrlParams() {
  const query = location.search.substr(1)
  const result = {}

  for (let part of query.split('&')) {

    if (!part) {
      return {}
    }
    // replace every + with space, regexp-free version
    part = part.split('+').join(' ')

    const eq = part.indexOf('=')
    let key = eq > -1 ? part.substr(0, eq) : part
    const val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : ''
    const from = key.indexOf('[')

    if (from == -1) {
      result[decodeURIComponent(key)] = val
    } else {
      let to = key.indexOf(']', from)
      let index = decodeURIComponent(key.substring(from + 1, to))
      key = decodeURIComponent(key.substring(0, from))
      if (!result[key]) {
        result[key] = []
      }
      if (!index) {
        result[key].push(val)
      } else {
        result[key][index] = val
      }
    }

  }

  return result
}


// WEBPACK FOOTER //
// ./src/service/url-manager.ts